import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(channel) {
  const genre = channel?.genres?.[0]?.name || "";

  return {
    title: `${channel.name}【${genre}】の注目の番組 動画配信 | SPOOX(スプークス)`,
    keywords: `注目の番組,${channel.name},SPOOX,スプークス,動画配信,スカパー！`,
    description: `${channel.name}の注目の番組をピックアップ！SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中です。`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.channelDetailFeatured(channel.id)}`,
    },
  };
}

export default function ChannelFeaturedMetaTags({ channel }) {
  const props = tags(channel);

  return <MetaTags {...props} />;
}
